import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createMutation } from '../http-client';
import { AuthDtoSchema } from '../types';

export type LoginParams = {
	username: string;
	password: string;
};

export const loginMutation = createMutation({
	params: declareParams<LoginParams>(),
	request: {
		method: 'POST',
		url: '/auth/in',
		body: (params) => params,
	},
	response: {
		contract: zodContract(AuthDtoSchema),
	},
});
